import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import Navigation from '@/components/shared/Navigation.vue';
import Footer from '@/components/shared/FooterSection.vue';
import { computed } from 'vue';
import { useStore } from 'vuex';
// import { useRoute } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
// const route = useRoute();
// console.log(route.name);

const isMenu = computed(() => store.getters.isMenuStatus);

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createVNode(Navigation, null, null, 512), [
      [_vShow, _unref(isMenu)]
    ]),
    _createVNode(_component_router_view),
    _createVNode(Footer)
  ], 64))
}
}

})